import { render } from "./Pagnination.vue?vue&type=template&id=64778618&scoped=true"
import script from "./Pagnination.vue?vue&type=script&lang=js"
export * from "./Pagnination.vue?vue&type=script&lang=js"

import "./Pagnination.vue?vue&type=style&index=0&id=64778618&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src886087124/src/dt-dashboard-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64778618"]])

export default __exports__